<template>
  <div class="p-30">
    <el-card class="m-b-20">
      <el-form label-width="250px">
        <el-form-item label="有效期限" class="required">
          <el-input
            v-model.trim="form.effectiveCycle"
            placeholder="请输入积分有效期，按天计算（0表示不限制）"
            :maxlength="10"
            class="input-width-380"
          />
        </el-form-item>
        <el-form-item label="消费抵扣" class="required">
          <el-input
            v-model.trim="form.consumeGrowMagnification"
            placeholder="请输入每消费1元抵扣积分值"
            :maxlength="10"
            class="input-width-380"
          />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-b-20">
      <div slot="header">基础任务</div>
      <el-form label-width="250px">
        <el-form-item v-for="(item, index) in basic" :key="index" :label="item.title" class="required">
          <el-input v-model.trim="item.firstValue" placeholder="请输入积分值" :maxlength="10" class="input-width-380" />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-b-20">
      <div slot="header">消费任务</div>
      <el-form label-width="250px">
        <el-form-item v-for="(item, index) in consume" :key="index" :label="item.title" class="required">
          <el-input placeholder="奖励上限" v-model="item.limitValue" class="input-with-select">
            <el-select v-model="item.limitType" slot="prepend" placeholder="请选择" class="input-select-task">
              <el-option label="日上限" value="day"></el-option>
              <el-option label="月上限" value="month"></el-option>
              <el-option label="人上限" value="user"></el-option>
            </el-select>
          </el-input>
          <el-input placeholder="请输入积分值" v-model="item.firstValue" class="input-select-task-item">
            <template slot="prepend">首次</template>
          </el-input>
          <el-input placeholder="请输入积分值" v-model="item.everyTimeValue" class="input-select-task-item">
            <template slot="append">积分值/次</template>
          </el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-b-20">
      <div slot="header">活跃任务</div>
      <el-form label-width="250px">
        <el-form-item v-for="(item, index) in active" :key="index" :label="item.title" class="required">
          <el-input placeholder="奖励上限" v-model="item.limitValue" class="input-with-select">
            <el-select v-model="item.limitType" slot="prepend" placeholder="请选择" class="input-select-task">
              <el-option label="日上限" value="day"></el-option>
              <el-option label="月上限" value="month"></el-option>
              <el-option label="人上限" value="user"></el-option>
            </el-select>
          </el-input>
          <el-input placeholder="请输入积分值" v-model="item.firstValue" class="input-select-task-item">
            <template slot="prepend">首次</template>
          </el-input>
          <el-input placeholder="请输入积分值" v-model="item.everyTimeValue" class="input-select-task-item">
            <template slot="append">积分值/次</template>
          </el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-b-20">
      <div class="m-t-20">
        <el-button @click="submit" type="primary" :loading="loading">立即提交</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { taskApi, taskUpdateApi } from '@/api/task'
export default {
  data() {
    return {
      form: {
        effective_cycle: '',
        consume_grow_magnification: ''
      },
      basic: [],
      consume: [],
      active: [],
      loading: false
    }
  },
  methods: {
    async loadTask() {
      const data = await taskApi({ withRels: ['rules'] })
      this.form = data.collection[0]
      this.form.rules.forEach(element => {
        if (element.type && element.type == 'basic') {
          this.basic.push(element)
        }
        if (element.type && element.type == 'consume') {
          this.consume.push(element)
        }
        if (element.type && element.type == 'active') {
          this.active.push(element)
        }
      })
    },
    async submit() {
      this.loading = true
      try {
        this.form.rules = []
        if (this.basic.length) {
          this.form.rules.push(...this.basic)
        }
        if (this.consume.length) {
          this.form.rules.push(...this.consume)
        }
        if (this.active.length) {
          this.form.rules.push(...this.active)
        }
        await taskUpdateApi(this.form)
        this.basic = []
        this.consume = []
        this.active = []
        this.loadTask()
      } finally {
        this.loading = false
      }
    }
  },
  created() {
    this.loadTask()
  }
}
</script>

<style scoped lang="less">
.required {
  /deep/.el-form-item__label::before {
    content: '*';
    display: inline-block;
    margin-right: 4px;
    color: #f56c6c;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
  }
}
.input-with-select {
  width: 150px;
  margin-right: 10px;
}
.input-select-task {
  width: 90px;
}
.input-select-task-item {
  width: 250px;
  margin-right: 10px;
}
.input-width-380 {
  width: 500px;
}
</style>
